import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toastr from "../../elements/toast";
import { useDispatch, useSelector } from "react-redux";
import { getLanguageCookie, getStorageValue, getZipCode, Regex, zipObjectCovert } from "../../../service/shared.service";
import httpApiCall from "../../../service/api.service";
import { useLocation, useNavigate } from "react-router-dom";
import Autocomplete, { usePlacesWidget } from "react-google-autocomplete";
import Nav from 'react-bootstrap/Nav';
import { copy, referral, eyeIconHide, eyeIconShow, backblack, dataLoading } from "../../../assets/assets";
import './new-sub-partner.scss'
import { Dropdown, Spinner } from "react-bootstrap";
import { saveAgentBusinessCount } from "../../../Redux/Slices/MainSlice";
import InputMask from 'react-input-mask';
import Table from "../../elements/tableComponent";
import { formatDate, formatDate2 } from "../../../utils/DateFormat";
import NoDataFound from "../../NoDataFound/NoDataFound";
import ConfirmationModal from "../../elements/confirmationModal";
import SendReminderModal from "../../elements/sendReminderModal";
import ReminderModal from "../../elements/reminderDetails";
import { handleInput } from "../../../service/common_function";



const NewSubPartner = () => {
  const navType = {
    NEWSUBPARTNER: 'NEWSUBPARTNER',
    DIRECTINVITE: 'DIRECTINVITE',
    LOGS: 'LOGS',
  }
  const copyClassType = {
    COPYREFERRALCODE: 'COPYREFERRALCODE',
    COPYREFERRALLINK: 'COPYREFERRALLINK',
  }
  const [phoneRegex, setPhoneRegex] = useState<{
  phoneRegexLength: string;
  phone_length: string | number;
  min_phone_length: string | number;
}>({
  phoneRegexLength: "",
  phone_length: "",
  min_phone_length:""
});
  const [partnerProfile, setPartnerProfile]: any = useState({});
  const [mobileCode, setMobileCode] = useState();
  const [agent_email, setAgentEmail] = useState('');
  // send reminder Variables
  const [isReminderModalOpen, setReminderModalOpen] = useState(false);
  const [itemToResend, setItemToResend] = useState(null);
  const [tabType, setTabType] = useState(navType.NEWSUBPARTNER);
  const [codeCopiedType, setCodeCopiedType] = useState('');
  const [country_code, setCountryCode]: any = useState([]);
  const [selectedZipCode, setZipCode]: any = useState({});
  let partnerData: any = getStorageValue('partnerData');
  const toastrService = new toastr(true);
  const location = useLocation();
  const [isModalOpen, setModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState({ id: '' });
  const [hidezipCode, setHidezipCode] = useState(false);
  const [data, setData] = useState({
    agent_name: "",
    agent_email: "",
    agent_mobile: "",
    agent_mobile_country_code: "",
    agent_address: "",
    language_preferred: '',
    zip: '',
    state_id: '',
    city_id: '',
    state: '',
    city: '',
    city_name: "",
    state_name: "",
  });
  const [isDetailModalOpen, setDetailModalOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);

  let answer = useSelector((state: any) => state.APIData.getSetting);
  const navigate = useNavigate();
  const [sppiner, setSppiner] = useState(false);

  const validationSchema = Yup.object({
    agent_name: Yup.string()
      .required("Please enter Sub partner name").matches(Regex.name, 'Invalid Sub partner name'),
    agent_email: Yup.string()
      .email("Invalid email format")
      .required("Please enter email"),
    agent_mobile: Yup.string().required("Please enter phone number").min(+phoneRegex.min_phone_length,`Phone number should be at least ${phoneRegex.min_phone_length} digits`).max(+phoneRegex.phone_length, `Phone number is not valid`),
    agent_address: Yup.string()
      .required("Please provide your address"),
    // language_preferred: Yup.string().required("Please select preferred communication langauge"),
    zip: Yup.string().required("Please enter Zip code"),
    // ind_id: Yup.string()
    // .required("Please select industry"),
    // sub_ind_id: Yup.string()
    // .required("Please select sub industry")
  });
  const dispatch = useDispatch();
  const [selectFieldIds, setSelectFieldIds] = useState({
    language_preferred: ''
  });
  const countData = useSelector((state: any) => state?.APIData?.agentBusinessCount);
  const language = useSelector((state: any) => state?.APIData?.getSetting?.language_data);
  const [shimmer, setShimmer] = useState(false);
  const [selectedChoice, setSelectedChoice] = useState({
    label: "All",
    value: 0,
  });

  const handleDelete = (item: any) => {
    const getIdData = logData[item[0] - 1];
    setItemToDelete(getIdData);
    setModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    const body: any = {
      access_token: getStorageValue("partnerToken"),
      refer_id: itemToDelete ? itemToDelete?.id : ''
    }

    setSppiner(true);
    setItemToDelete({ id: '' });
    setModalOpen(false);
    let resp = await httpApiCall({ api: "delete_doctor_referral", type: "post", body });
    setSppiner(false);
    if (resp && !resp.is_error) {
      getReferrals();
    } else {
      toastrService.showError(resp?.err)
    }
  }

  const handleCloseModal = () => {
    setItemToDelete({ id: '' })
    setModalOpen(false);
  };

  const handleSendReminder = (item: any) => {
    const getIdData = logData[item[0] - 1];
    const reminderObj = getIdData?.reminder_obj ? JSON.parse(getIdData.reminder_obj) : [];

    let referralMobile =
      !getIdData.referral_mobile && reminderObj.length
        ? reminderObj[reminderObj.length - 1]?.referral_mobile || ''
        : getIdData.referral_mobile || '';

    setItemToResend({
      ...getIdData,
      referral_mobile: referralMobile,
    });

    setReminderModalOpen(true);
  };

  const handleReminderCloseModal = () => {
    setItemToResend(null)
    setReminderModalOpen(false);
  };

  const handleConfirmReminder = () => {

    setReminderModalOpen(false);
    getReferrals();

  };

  const showDetail = (detail: any) => {
    const getIdData = logData[detail[0] - 1];
    setDetailData(getIdData);
    setDetailModalOpen(true)
  }

  const handleDetailClose = () => {
    setDetailModalOpen(false)
  }



  const [directInvite, setDirectInvite] = useState({
    agent_name: "",
    agent_email: "",
    agent_mobile: "",
    agent_mobile_country_code: "",
    language_preffered: "en",
    notes: ''
  });


  const directInviteValidation = Yup.object({
    agent_name: Yup.string().required("Please enter name").matches(Regex.name, 'Invalid name'),
    agent_email: Yup.string().email("Invalid email format").matches(Regex.email, "Please enter a valid email"),
    agent_mobile: Yup.string(),
    // language_preffered: Yup.string().required("Please select language"),
    notes: Yup.string().required("Please enter notes"),

  });

  const handleInviteSubmit = async (formData: any, { resetForm }: any) => {
    toastrService.dismiss();
    if ((formData.agent_name).length > 100) {
      toastrService.showError('Please enter valid name');
      return;
    }
    if ((!formData.agent_email.trim().length) && (formData.agent_mobile.trim().length < 6)) {
      toastrService.showError('Please enter valid phone no or email');
      return;
    }
    const profileData = getStorageValue("partnerProfile");
    const body: any = {
      access_token: getStorageValue("partnerToken"),
      invite_email: formData.agent_email || null,
      // invite_name: formData.agent_name,
      invite_mobile: formData.agent_mobile,
      invite_mobile_country_code: formData.agent_mobile ? mobileCode : '',
      language_preffered: 'en',
      notes: formData.notes,
      referral_code: profileData && profileData.length ? profileData[0]['referral_code'] : '',
      referral_name: formData.agent_name,
      is_agent: 1,
      referral_parent_id: null,
      is_resend_reminder: 0
    }
    setSppiner(true);
    let resp = await httpApiCall({ api: "send_invite", type: "post", body });
    setSppiner(false);
    if (resp && !resp.is_error) {
      resetForm();
      setLogData([]);
      setTabType(navType.LOGS);
      getReferrals();
      toastrService.showSuccess("Invite has been sent successfully");
    } else {

      toastrService.showError(resp.original_text || resp.err);
    }

  };



  const langList = [{ value: 'en', label: "English" }, { value: 'de', label: "Deutsch" }, { value: 'es', label: "Español" }, { value: 'fr', label: "Französisch" },
  { value: 'it', label: "Italiano" }, { value: 'ja', label: "日本語" }, { value: 'pl', label: "Polski" }, { value: 'ru', label: "Русский" }]
  const [logData, setLogData] = useState<any>();
  const choices = [
    {
      value: 0,
      label: "All",
    },
    {
      value: 1,
      label: "Registered",
    },
    {
      value: 2,
      label: "Not Registered",
    },
  ];
  const columns = [
    { title: "S.No.", dataKey: "sno" },
    { title: "Referral Details", dataKey: "referral_email" },
    { title: "Referral Date", dataKey: "date_added" },
    { title: "Last Reminder", dataKey: "last_date_added" },
    { title: "Status", dataKey: "status" },
    { title: "", dataKey: "action" },
    { title: "", dataKey: "reminder" },
    { title: "", dataKey: "details" }
  ];
  const rows =
    logData &&
    logData.map((row: any, index: number) => [
      index + 1,
      <>
        <span>{row.referral_name}</span><br />
        {row?.referral_email && (
          <>
            <span>{row.referral_email}</span><br />
          </>
        )}
        {row?.referral_mobile && (
          <span>{row.referral_mobile}</span>
        )}
      </>,
      formatDate2(row.date_added),
      JSON.parse(row?.reminder_obj).length ? formatDate2(JSON.parse(row?.reminder_obj)[JSON.parse(row?.reminder_obj).length - 1]?.date_added) : 'N.A',
      row.status == 0 ? 'Not Registered' : 'Registered'
    ]);
  useEffect(() => {
    setPartnerProfile(partnerData)
    if (partnerData && partnerData.country_currency_info && partnerData.country_currency_info.country) {
      setMobileCode(partnerData.country_currency_info.country.mobile_code);
    }
    if (partnerData && partnerData.country_currency_info && partnerData.country_currency_info.country) {
      partnerData['country_code'] = partnerData.country_currency_info.country['country_code'];
      let countries = [];
      countries.push(partnerData["country_code"]);
      const US_UT_country_codes = ["VI", "PR", "GU", "AS", "MP"];
      if (partnerData["country_code"] == "US") {
        countries = [...countries, ...US_UT_country_codes];
      }
      setCountryCode(countries);
    }
    if (!answer || (answer && !answer.country_data)) {
      answer = getStorageValue('settingsData');
    }
    if (partnerData && partnerData.country_currency_info && partnerData.country_currency_info.country) {
      const countryData = answer.country_data.filter((item: any) => item['country_id'] == partnerData.country_currency_info.country['country_id']);
      if (countryData && countryData.length) {
        updateMasking(countryData[0]['country_phone_format']);
        setPhoneRegex((data) => ({
          ...data,
          phone_length: countryData[0]['phone_length'] || 12,
          min_phone_length: countryData[0]['min_phone_length'] || 7
        }));
      }
    }
  }, []);

  const placeSelectedZip = async (place: any, setFieldValue: any) => {
    setSppiner(true);
    setHidezipCode(true);
    const placeData = await getZipCode(zipObjectCovert(place));
    if (placeData && placeData.city) {
      setSppiner(false);
      setZipCode(placeData);
      data.city = placeData.city;
      data.state = placeData.state_name;
      data.zip = placeData.zip;
      setData((agentData) => ({
        ...agentData,
        state_name: placeData.state_name,
        city_name: placeData.city,
        city_id: placeData.city_id,
        zip: placeData.zip,
      }))
      setFieldValue("state_name", placeData.state_name);
      setFieldValue("city_name", placeData.city);
      setFieldValue("zip", placeData.zip);
    } else {
      toastrService.showError('Please enter another zip code');
    }
    setHidezipCode(false);
  }

  const updateMasking = (format: "") => {
    const phoneRegexVar = format?.replace(/#/g, "9");
    // phoneRegex = phoneRegexVar;
    setPhoneRegex((data) => ({
      ...data,
      phoneRegexLength: phoneRegexVar
    }));
  }

  const handleSubmit = async (formData: any) => {
    const language_preffered = await getLanguageCookie();
    const profileData = getStorageValue('partnerProfile');
    if (!data.city_id) {
      toastrService.showError('Please enter valid zip code');
      return;
    }
    if ((formData.agent_name + '').length > 100) {
      toastrService.showError('Please enter valid name');
      return;
    }
    const body = {
      access_token: getStorageValue('partnerToken'),
      agent_email: formData.agent_email,
      // title: formData.agent_title,
      agent_name: formData.agent_name,
      partner_mobile: formData.agent_mobile,
      partner_mobile_country_code: mobileCode,
      country_id: partnerData.country_currency_info && partnerData.country_currency_info.country['country_id'],
      currency_id: partnerData.country_currency_info && partnerData.country_currency_info.currency && partnerData.country_currency_info.currency[0]['currency_id'],
      referral_code: profileData && profileData.length ? profileData[0]['referral_code'] : '',
      agent_address: formData.agent_address,
      city_id: data.city_id,
      language_preffered: 'en', //selectFieldIds.language_preferred || language_preffered,
      para_id: partnerData && partnerData['partner_profile'][0].para_id,
      partner_json: partnerData && partnerData['partner_profile'][0].partner_json,
      // partner_mobile :partnerData && partnerData['partner_profile'][0].partner_mobile,
      // pu_id: pu_id ? pu_id : undefined
    };
    setSppiner(true);
    httpApiCall({ api: "add_agent", type: "post", body }).then(resp => {
      setSppiner(false);
      if (resp && !resp.is_error) {
        dispatch(saveAgentBusinessCount({
          total_agents: Number(countData.total_agents) + 1,
          total_business: countData.total_business
        }))
        toastrService.showSuccess('Sub partner added sucessfully');
        setTimeout(() => {
          navigate('/app/sub-partner');
        })
      } else {
        toastrService.showError(resp.original_text || resp.err);
      }
    }).catch((error) => {
    });
  }

  // const sendInvite = async (formData:any) => {
  //   const checkEmail = Regex.email;
  //   if (!agent_email || (agent_email && !((agent_email + '').trim()).length) || !checkEmail.test(agent_email)) {
  //     toastrService.showError('Please enter valid partner email'); 
  //     return;
  //   }

  // }

  const copyToClipboard = async (code: any, type: any) => {
    setCodeCopiedType(type);
    navigator.clipboard.writeText(code);
    setTimeout(() => {
      setCodeCopiedType('');
    }, 3000)
  }

  const onPhoneChange = (event: any, setFieldValue: any) => {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/[^0-9]+/g, "");
    }
    setData((agentData) => ({
      ...agentData,
      agent_mobile: event.target.value
    }));
    setFieldValue('agent_mobile', event.target.value);
  };

  const getReferrals = async (filter = 0) => {
    setShimmer(true);
    const body = {
      access_token: getStorageValue("partnerToken"),
      limit: 10,
      offset: 0,
      filter,
      is_agent: 1
    }
    const data = await httpApiCall({ api: "get_partner_referrals", type: "post", body });
    setShimmer(false);
    if (!data.is_error) {
      setLogData(data.referrals)
    } else {
      setLogData([])
    }
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-2 col-lg-3">
            <div className="nav_tabs -d-flex justify-content-center">
              <div className="back d-none d-md-block my-2">
                <button
                  className="mb-0 border-0 bg-transparent ps-0"
                  onClick={() => navigate("/app/sub-partner")}
                >
                  <img src={backblack} alt="" />
                  Back
                </button>
              </div>
              <Nav.Item
                style={{ padding: "15px" }}
                className={tabType == navType.NEWSUBPARTNER ? "active" : ""}
                onClick={() => setTabType(navType.NEWSUBPARTNER)}
              >
                Add Sub Partner
              </Nav.Item>
              <Nav.Item
                style={{ padding: "15px" }}
                className={tabType == navType.DIRECTINVITE ? "active" : ""}
                onClick={() => setTabType(navType.DIRECTINVITE)}
              >
                Direct Invite
              </Nav.Item>
              <Nav.Item
                style={{ padding: "15px" }}
                className={tabType == navType.LOGS ? "active" : ""}
                onClick={() => (
                  setLogData([]),
                  setTabType(navType.LOGS),
                  getReferrals()
                )
                }
              >
                Invited Sub Partner Logs
              </Nav.Item>
            </div>

        </div>
        <div className="col-xl-10 col-lg-9 py-4">
        {tabType == navType.NEWSUBPARTNER && (
        <div className="Add_business">
          {" "}
          <div className="flow-right">
            <Formik
              onSubmit={handleSubmit}
              initialValues={data}
              validationSchema={validationSchema}
            >
              {({ setFieldValue, setFieldTouched }) => (
                <Form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="" className="labels_input">
                          Sub partner Name
                        </label>
                        <Field autocomplete="agent_name"
                          className="form-control"
                          type="text"
                          name="agent_name"
                          placeholder="Enter Sub partner name"
                          id="agent_name"
                        />
                        <small className="text-danger m-2">
                          <ErrorMessage name="agent_name" />
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="" className="labels_input">
                          Email
                        </label>
                        <Field autocomplete="agent_email"
                          className="form-control"
                          type="email"
                          name="agent_email"
                          placeholder="Enter email"
                          id="agent_email"
                        />
                        <small className="text-danger m-2">
                          <ErrorMessage name="agent_email" />
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="" className="labels_input">
                          Phone
                        </label>
                        <div className="mobilecode">
                          <p>{mobileCode}</p>
                          <div className="hide_show">
                            <Field autocomplete="agent_mobile"
                              className="form-control"
                              type="tel"
                              id="agent_mobile"
                              name="agent_mobile">
                              {
                                (props: any) => <InputMask
                                  type="text"
                                  mask={phoneRegex.phoneRegexLength}
                                  maskChar={null}
                                  onChange={(event) =>  onPhoneChange(event, setFieldValue)}
                                  className="text-input form-control"
                                  id="agent_phone"
                                   minLength={+phoneRegex.min_phone_length}
                                  maxLength={+phoneRegex.phone_length}
                                />
                              }
                                  </Field>
                                </div>
                              </div>
                              <small className="text-danger m-2">
                                <ErrorMessage name="agent_mobile" />
                              </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                Address
                              </label>
                              <div className="address">
                                <div className="hide_show">
                                  <Field autoComplete="agent_address"
                                    className="form-control"
                                    type="text"
                                    name="agent_address"
                                    id="agent_address"
                                    placeholder="Enter address"
                                  />
                                </div>
                              </div>
                              <small className="text-danger m-2">
                                <ErrorMessage name="agent_address" />
                              </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                Zip Code
                              </label>
                              <div className="address">
                                <div className="hide_show">
                                  {country_code && (
                                    <div style={{ 'border': 'solid 1px #dee2e6', 'borderRadius': '0.375rem', 'minHeight': '42px' }}>
                                      {!hidezipCode && <Autocomplete
                                        apiKey={getStorageValue("map_api_key")}
                                        className="form-control"
                                        id="country_code"
                                        // defaultValue="Amsterdam"
                                        style={{
                                          width: "100%",
                                          height: "40px",
                                          paddingLeft: "16px",
                                        }}
                                        onPlaceSelected={(place) => {
                                          placeSelectedZip(place, setFieldValue);
                                          setFieldTouched("zip", false);
                                          // console.log(place);
                                          // console.log(partnerData['country_code'])
                                          // setFieldValue("zip", country_code);
                                        }}
                                        inputAutocompleteValue="zip"
                                        options={{
                                          fields: [
                                            "address_components",
                                            "adr_address",
                                            "geometry",
                                            "name",
                                            "formatted_address",
                                          ],
                                          types: ["(regions)"],

                                          componentRestrictions: {
                                            country: country_code,
                                          },
                                        }}
                                        defaultValue={data.zip}
                                      />}
                                    </div>
                                  )}
                                  <ErrorMessage name="zip" component="small" className="text-danger m-2" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                State
                              </label>
                              <div className="address">
                                <div className="hide_show">
                                  <Field
                                    disabled
                                    className="form-control"
                                    type="text"
                                    name="state"
                                    value={data.state_name}
                                    id="state-name"
                                  />
                                </div>
                              </div>
                              <small className="text-danger m-2">
                                <ErrorMessage name="state" />
                              </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                City
                              </label>
                              <div className="address">
                                <div className="hide_show">
                                  <Field
                                    disabled
                                    className="form-control"
                                    type="text"
                                    name="city"
                                    value={data.city_name}
                                    id="city-name"
                                  />
                                </div>
                              </div>
                              <small className="text-danger m-2">
                                <ErrorMessage name="city" />
                              </small>
                            </div>
                          </div>
                          {/* <div className="col-md-6">
                      <div className="form-group mb-3 arrowSelect">
                        <label htmlFor="" className="labels_input">
                          Preferred communication language
                        </label>
                        <Field
                          className="form-control"
                          as="select"
                          name="language_preferred"
                          onChange={(event: any) => {
                            setSelectFieldIds((data: any) => ({
                              language_preferred: event.target.value,
                            }));
                            setFieldValue(
                              "language_preferred",
                              event.target.value
                            );
                          }}
                          value={selectFieldIds.language_preferred}
                        >
                          <option disabled key={0} value={""}>
                            {"Select language"}
                          </option>
                          {language &&
                            language.map((e: any, i: any) => (
                              <option key={i} value={e.lan_code}>
                                {e.lan_name}
                              </option>
                            ))}
                        </Field>
                        <small className="text-danger m-2">
                          <ErrorMessage name="language_preferred" />
                        </small>
                      </div>
                    </div> */}
                          <div className="col-12 button_chase mt-3">
                            <button
                              disabled={sppiner}
                              className="loginBtn"
                              type="submit"
                            >
                              Add Sub Partner
                              {sppiner && (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  className="ms-2"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            )}
            {tabType == navType.DIRECTINVITE && (
              <div className="Add_business d-flex">
                <div className="row">
                  <div className="col-md-6">
                    <div className="direct_invite ">
                      <div className="form-group d-flex justify-content-center flex-column">
                        <Formik
                          onSubmit={handleInviteSubmit}
                          initialValues={directInvite}
                          validationSchema={directInviteValidation}>
                          {({ setFieldValue }) => (
                            <Form>
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <label htmlFor="" className="labels_input">
                                      Sub Partner Name
                                    </label>
                                    <Field
                                      className="form-control invite"
                                      id="business_first_name"
                                      type="text"
                                      name="agent_name"
                                      placeholder="Enter sub-partner name"
                                    />
                                    <small className="text-danger m-2">
                                      <ErrorMessage name="agent_name" />
                                    </small>
                                  </div>
                                </div>

                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <label htmlFor="" className="labels_input">
                                      Sub Partner E-mail
                                    </label>
                                    <Field
                                      className="form-control invite"
                                      type="email"
                                      id="agent_email"
                                      name="agent_email"
                                      placeholder="Enter sub-partner email"
                                    />
                                    <small className="text-danger m-2">
                                      <ErrorMessage name="agent_email" />
                                    </small>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  {phoneRegex && <div className="form-group">
                                    <label htmlFor="" className="labels_input">
                                      Sub Partner Phone
                                    </label>
                                    <div className="mobilecode">
                                      <p>{mobileCode}</p>
                                      <div className="hide_show">
                                        <Field
                                          name="agent_mobile"
                                          className="form-control invite"
                                          id="agent_mobile"
                                        >
                                          {
                                            (props: any) => <InputMask
                                              type="text"
                                              mask={phoneRegex.phoneRegexLength}
                                              maskChar={null}
                                              onChange={(event) => onPhoneChange(event, setFieldValue)}
                                              className="text-input form-control invite"
                                              id="agent_mobile"
                                              minLength={+phoneRegex.min_phone_length}
                                  maxLength={+phoneRegex.phone_length}
                                            />
                                          }
                                        </Field>
                                      </div>
                                    </div>
                                    {!data.agent_mobile && <small className="text-danger m-2">
                                      <ErrorMessage name="doctor_mobile" />
                                    </small>}
                                  </div>}
                                </div>
                                {/* <div className="form-group arrowSelect">
                                  <label htmlFor="" className="labels_input">
                                    Select Preferred Language
                                  </label>
                                  <Field
                                    className="form-control invite"
                                    as="select"
                                    name="language_preffered"
                                    id="language_preffered"
                                    onChange={(event: any) => {
                                      setDirectInvite((data: any) => ({
                                        ...data,
                                        language_preffered: event.target.value
                                      }))
                                      setFieldValue("language_preffered", event.target.value)
                                    }}
                                    value={directInvite.language_preffered}
                                  >
                                    <option disabled key={0} value={""}>
                                      {"Select preferred language"}
                                    </option>
                                    {langList.map((e: any, i: any) => (
                                      <option key={i} value={e.value}>
                                        {e.label}
                                      </option>
                                    ))}
                                  </Field>
                                  <small className="text-danger m-2">
                                    <ErrorMessage name="language_preffered" />
                                  </small>
                                </div> */}
                                <div className="col-12">
                                  <div className="form-group">
                                    <label htmlFor="" className="labels_input">Notes</label>
                                    <Field
                                      className="form-control"
                                      as="textarea"
                                      id="notes"
                                      name="notes"
                                      rows="5"
                                      cols="40"
                                      onKeyDown={handleInput}
                                    />
                                    <small className="text-danger m-2">
                                      <ErrorMessage name="notes" />
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div className="button_chase">
                                <button disabled={sppiner} className="loginBtn" type="submit">
                                  Send Invite
                                  {sppiner && (
                                    <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                      className="ms-2"
                                    />
                                  )}
                                </button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="referal_invite text-center">
                      <div style={{ fontSize: "14px" }}>
                        <div className="text-center">
                          <img className="me-2 mb-3 referImg" src={referral} alt="" />
                        </div>
                        {/* <img className="me-3" src={referral} alt="" /> */}
                        You can send referral code or url link to send invite
                      </div>
                      <div className="mt-3">
                        {partnerProfile.partner_profile &&
                          partnerProfile.partner_profile.length && (
                            <div
                              className={`referral-box ${codeCopiedType == copyClassType.COPYREFERRALCODE
                                ? "copied"
                                : ""
                                }`}
                              onClick={() =>
                                copyToClipboard(
                                  partnerProfile.partner_profile[0]["referral_code"],
                                  copyClassType.COPYREFERRALCODE
                                )
                              }
                            >
                              {codeCopiedType == copyClassType.COPYREFERRALCODE
                                ? "Copied"
                                : partnerProfile.partner_profile[0]["referral_code"]}
                              <img
                                className="ml-4"
                                src={copy}
                                alt=""
                                style={{ width: "20px" }}
                              />
                            </div>
                          )}
                        {partnerProfile["referral_link_partner"] && (
                          <div
                            className={`referral-box mt-3 ${codeCopiedType == copyClassType.COPYREFERRALLINK
                              ? "copied"
                              : ""
                              }`}
                            style={{ maxWidth: "300px" }}
                            onClick={() =>
                              copyToClipboard(
                                partnerProfile["referral_link_partner"],
                                copyClassType.COPYREFERRALLINK
                              )
                            }
                          >
                            <span>
                              {codeCopiedType == copyClassType.COPYREFERRALLINK
                                ? "Copied"
                                : partnerProfile["referral_link_partner"]}
                            </span>
                            <img
                              className="ml-4"
                              src={copy}
                              alt=""
                              style={{ width: "20px" }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {isModalOpen && <ConfirmationModal
              onClose={handleCloseModal}
              onConfirm={handleConfirmDelete}
              message={`Are you sure you want to delete this invite?`}
            />}
            {isReminderModalOpen && <SendReminderModal
              onClose={handleReminderCloseModal}
              onConfirm={handleConfirmReminder}
              reminderData={itemToResend}
              mobileCode={mobileCode}
              mobileRegex={phoneRegex}
              type={'SubPartner'}
            />}
             <ReminderModal
              isOpen={isDetailModalOpen}
              onClose={handleDetailClose}
              data={detailData} />

            {tabType == navType.LOGS && (
              <>
                <div className="">
                  <div className="filterDropdown d-inline-block position-relative">
                    <Dropdown autoClose={true} style={{ 'padding': '0px 30px' }}>
                      <Dropdown.Toggle variant="primary"
                      >
                        {selectedChoice.label}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {choices.map((item, index) => (
                          <Dropdown.Item href="#"
                            key={index}
                            onClick={() => (
                              getReferrals(item.value),
                              setSelectedChoice({ value: item.value, label: item.label })
                            )}
                          >
                            {item.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {shimmer && (
                    <div className="no_data_v2 text-center">
                      <img src={dataLoading} alt="" />
                    </div>
                  )}
                  {!shimmer && (logData && logData.length > 0) &&
                    <div className="table-data-logs" style={{ 'padding': '7px 30px' }}>
                      <Table callFunction={() => console.log('call from new sub')} deleteItem={(values: any) => handleDelete(values)}
                        sendReminder={(values: any) => handleSendReminder(values)} showDetail={(detail: any) => showDetail(detail)}
                        data={rows} columns={columns} showAction={true} ></Table>
                    </div>}
                  {!shimmer && (!logData || (logData && !logData.length)) &&
                    <div className="no_data_v2 text-center">
                      <NoDataFound />
                    </div>
                  }
                </div>
              </>
            )}

          </div>
        </div>
      </div>


    </>
  );
}

export default NewSubPartner;
